import { User } from '../codegen/graphql';
import { UserRole } from '../types/users';

export const checkUserRole = (
    user?: User | null,
    roles: UserRole[] = [UserRole.SUPER_ADMIN],
): boolean => {
    if (!user?.userRole?.role) return false;
    const normalizedRole = user.userRole.role.toLowerCase();
    return roles.includes(normalizedRole as UserRole);
};

export const normalizeAuthRole = (role?: string | null): string => {
    return (role || '').toLowerCase().replace(/\s/g, '');
};

export const isUserAdmin = (user?: User | null): boolean => {
    if (!user?.userRole?.role) return false;

    const normalizedRole = normalizeAuthRole(user.userRole.role);
    return (
        normalizedRole === 'admin' ||
        normalizedRole === 'superadmin' ||
        checkUserRole(user, [UserRole.ADMIN, UserRole.SUPER_ADMIN])
    );
};
